import { getMixin } from '@mpxjs/core';
export default getMixin({});
